



































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		id: {
			type: Number,
			default: 1
		},
		mois: {
			type: Number,
			default: 1
		}
	}
});

@Component
export default class ArticleTemplate extends Props {
}
